import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-scroll';

const navItems = [
	{ label: 'Home', to: 'hero' },
	{ label: 'Skills', to: 'skills' },
	{ label: 'Projects', to: 'projects' },
	{ label: 'Experience', to: 'experiences' },
	{ label: 'Education', to: 'education' },
	{ label: 'Contact', to: 'contacts' },
];

function Header() {
	const [scrolled, setScrolled] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);

	useEffect(() => {
		const handler = () => setScrolled(window.scrollY > 30);
		window.addEventListener('scroll', handler);
		return () => window.removeEventListener('scroll', handler);
	}, []);

	return (
		<header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
			scrolled ? 'py-3 bg-primary/80 backdrop-blur-xl border-b border-slate-800/80 shadow-[0_1px_0_rgba(255,255,255,0.05)]' : 'py-5 bg-transparent'
		}`}>
			<div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
				<Link to="hero" smooth duration={500} className="cursor-pointer group">
					<span className="font-display font-bold text-xl text-white tracking-tight">
						KL<span className="text-accent transition-all duration-300 group-hover:text-accent-2">.</span>
					</span>
				</Link>

				<nav className="hidden md:flex items-center gap-8">
					{navItems.map((item) => (
						<Link key={item.to} to={item.to} spy smooth offset={-80} duration={600}
							activeClass="!text-white after:!w-full"
							className="nav-link">
							{item.label}
						</Link>
					))}
				</nav>

				<a href="https://drive.google.com/file/d/1sZL5kAwmhzgzsdsrki3DeRywPJBBETeo/view?usp=sharing"
					target="_blank" rel="noreferrer"
					className="hidden md:inline-flex items-center gap-2 text-xs font-semibold px-4 py-2 rounded-lg border border-slate-700 text-slate-300 hover:border-accent hover:text-white hover:bg-accent/10 transition-all duration-300">
					<Icon icon="mdi:file-document-outline" />
					Resume
				</a>

				<button className="md:hidden text-slate-300 hover:text-white p-1 transition-colors"
					onClick={() => setMenuOpen(s => !s)} aria-label="Toggle menu">
					<Icon icon={menuOpen ? 'mdi:close' : 'mdi:menu'} className="text-2xl" />
				</button>
			</div>

			{menuOpen && (
				<div className="md:hidden mt-2 mx-4 rounded-2xl glass-card border border-slate-700/50 overflow-hidden animate-fade-in">
					<nav className="p-4 flex flex-col gap-1">
						{navItems.map((item) => (
							<Link key={item.to} to={item.to} spy smooth offset={-80} duration={600}
								onClick={() => setMenuOpen(false)}
								className="text-slate-300 hover:text-white py-2.5 px-4 rounded-xl hover:bg-white/5 transition-colors cursor-pointer text-sm font-medium">
								{item.label}
							</Link>
						))}
					</nav>
				</div>
			)}
		</header>
	);
}

export default Header;
